// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/deliverable_import.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CommitDeliverableImportWorkstreamRequest, CommitDeliverableImportWorkstreamResponse, GetDeliverableImportReviewRequest, GetDeliverableImportReviewResponse, ResolveDeliverableImportProposalRequest, ResolveDeliverableImportProposalResponse, ReviseDeliverableImportProposalRequest, ReviseDeliverableImportProposalResponse, StageDeliverableImportRequest, StageDeliverableImportResponse } from "./deliverable_import_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * DeliverableImportService backs Journey A01, "Seed a deliverables schedule
 * from Excel": an agent (shanks) reads a workbook and stages PROPOSED
 * deliverables into a server-side ledger; a human Program Lead reviews each
 * one (approve / edit-then-approve / reject / defer) in thousand-sunny; then
 * commits one workstream at a time, which writes program tasks and verifies
 * them by reading them back from storage.
 *
 * Authorization: StageDeliverableImport, GetDeliverableImportReview,
 * ResolveDeliverableImportProposal and ReviseDeliverableImportProposal are
 * restricted to the Program Lead role (enforced in ryugu). The agent calls
 * StageDeliverableImport on the Program Lead's behalf during the chat
 * session; it never calls Resolve/Revise/Commit itself.
 *
 * CommitDeliverableImportWorkstream is reachable ONLY from the browser,
 * invoked directly by the human clicking commit — never by the agent. This
 * is the one point in the journey where the AI is not the caller, because
 * this is the one call that writes program data.
 *
 * A staged proposal is review-only data: it does not appear anywhere in
 * Tasks, and nothing it holds is visible outside this service's review
 * surface, until CommitDeliverableImportWorkstream has written and verified
 * it.
 *
 * @generated from service mono.ryugu.v1.DeliverableImportService
 */ export const DeliverableImportService = {
    typeName: "mono.ryugu.v1.DeliverableImportService",
    methods: {
        /**
     * Creates a new import ledger (change_set_id empty) or appends more staged
     * proposals to an existing one (change_set_id set) — the workbook may be
     * staged in batches as the agent works through it sheet by sheet.
     *
     * @generated from rpc mono.ryugu.v1.DeliverableImportService.StageDeliverableImport
     */ stageDeliverableImport: {
            name: "StageDeliverableImport",
            I: StageDeliverableImportRequest,
            O: StageDeliverableImportResponse,
            kind: MethodKind.Unary
        },
        /**
     * Returns server truth for a staged import: per-workstream review counts
     * plus the full proposal list (optionally filtered). The UI always renders
     * from this call, never from a DeliverableImportCard's own fields.
     *
     * @generated from rpc mono.ryugu.v1.DeliverableImportService.GetDeliverableImportReview
     */ getDeliverableImportReview: {
            name: "GetDeliverableImportReview",
            I: GetDeliverableImportReviewRequest,
            O: GetDeliverableImportReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * Records the Program Lead's verdict — approve, reject, or defer — on one
     * proposal, with an optional rationale.
     *
     * @generated from rpc mono.ryugu.v1.DeliverableImportService.ResolveDeliverableImportProposal
     */ resolveDeliverableImportProposal: {
            name: "ResolveDeliverableImportProposal",
            I: ResolveDeliverableImportProposalRequest,
            O: ResolveDeliverableImportProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * Creates a new revision that supersedes a proposal with edited fields.
     * The new revision starts PENDING and the superseded proposal moves to
     * SUPERSEDED; review starts over for the revised proposal.
     *
     * @generated from rpc mono.ryugu.v1.DeliverableImportService.ReviseDeliverableImportProposal
     */ reviseDeliverableImportProposal: {
            name: "ReviseDeliverableImportProposal",
            I: ReviseDeliverableImportProposalRequest,
            O: ReviseDeliverableImportProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * Human-only, browser-only. Writes program tasks for every APPROVED /
     * EDITED_APPROVED proposal in one workstream and verifies each by reading
     * it back from storage before reporting success.
     *
     * @generated from rpc mono.ryugu.v1.DeliverableImportService.CommitDeliverableImportWorkstream
     */ commitDeliverableImportWorkstream: {
            name: "CommitDeliverableImportWorkstream",
            I: CommitDeliverableImportWorkstreamRequest,
            O: CommitDeliverableImportWorkstreamResponse,
            kind: MethodKind.Unary
        }
    }
};
